// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"ItemSuggestion_modalHeader__3X35E","popoverStyling":"ItemSuggestion_popoverStyling__1OKMA","itemContainer":"ItemSuggestion_itemContainer__CgTFE"};